import { API } from "aws-amplify";

export interface FamilyGroup {
  sano: string;
  fechaNacimiento: string;
  parentesco: string;
  genero: string;
}

export interface Modality {
  position: string;
  diferido: string;
  garantizado: string;
  anosTemporales?: string;
  moneda: string;
  modalidad: string;
}

export interface RequestRVEO {
  asesor: string;
  cuspp: string;
  fechaCalculo: string;
  prestacion: string;
  capitalPension: string;
  fechaDevengue: string;
  fechaDevengueOriginal: string | null;
  gratificacion: string;
  grupoFamiliar: FamilyGroup[];
  modalidades: Modality[];
  tipoCotizacion: string;
  phone: string;
  cellphone: string;
  tipoDireccion: string;
  salud: string;
  afp: number;
  cic: number;
  remprom: number;
  address: string;
  contribucion: number;
  bonoReconocimiento: number;
  coverage: string;
  email: string;
  asegurado: any;
}

export const submitRVQuotation = async (requestData: RequestRVEO) => {
  try {
    const response = await API.post("cotizacion-extraoficial", "/extraoficial/cotizar", {
      body: {payload: requestData},
      headers: {},
    });

    return response;
  } catch (error) {
    console.error("Error en submitRVQuotation:", error);
    throw error;
  }
};
